import { useAsyncCallback } from '../../../hooks'
import {
  EntityAsyncMultiValuedInfiniteListMoreItems,
  EntityMultiValuedListMoreItem,
} from '../../Entity'
import { MultiValuedList } from '../../MultiValuedList'
import { TextMultiValuedListItem } from '../../TextMultiValuedList'
import { getCategories } from '../Category.api'

import { getDataItems } from './TableCategoryListCell.utils'

function CategoryMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = EntityMultiValuedListMoreItem,
  MoreItems = EntityAsyncMultiValuedInfiniteListMoreItems,
  apiParams,
  ...restProps
}) {
  const handleLoadData = useAsyncCallback(params => {
    return getCategories(null, params)
  }, [])

  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      MoreItems={MoreItems}
      moreItemsProps={{
        apiParams,
        getData: handleLoadData,
        getDataItems,
      }}
    />
  )
}

export default CategoryMultiValuedList
